var map = {
	"./asia/bali/bali-cities.json": 47002,
	"./asia/bangladesh/bangladesh-cities.json": 51744,
	"./asia/bhutan/bhutan-cities.json": 18570,
	"./asia/cambodia/cambodia-cities.json": 94814,
	"./asia/china/china-cities.json": 28720,
	"./asia/country/country-cities.json": 47096,
	"./asia/hongkong/hongkong-cities.json": 6848,
	"./asia/india/india-cities.json": 71792,
	"./asia/indonesia/indonesia-cities.json": 19356,
	"./asia/japan/japan-cities.json": 23336,
	"./asia/korea/korea-cities.json": 88352,
	"./asia/laos/laos-cities.json": 80240,
	"./asia/malaysia/malaysia-cities.json": 50608,
	"./asia/mongolia/mongolia-cities.json": 2678,
	"./asia/myanmar/myanmar-cities.json": 7104,
	"./asia/nepal/nepal-cities.json": 93964,
	"./asia/singapore/singapore-cities.json": 12780,
	"./asia/srilanka/srilanka-cities.json": 26044,
	"./asia/taiwan/taiwan-cities.json": 65118,
	"./asia/thailand/thailand-cities.json": 46448,
	"./asia/thephilippines/thephilippines-cities.json": 9766,
	"./asia/vietnam/vietnam-cities.json": 92832,
	"./europe/amsterdam/amsterdam-cities.json": 79132,
	"./europe/country/country-cities.json": 55656,
	"./europe/croatia/croatia-cities.json": 28204,
	"./europe/estonia/estonia-cities.json": 320,
	"./europe/france/france-cities.json": 52180,
	"./europe/germany/germany-cities.json": 3844,
	"./europe/greece/greece-cities.json": 49648,
	"./europe/iceland/iceland-cities.json": 72796,
	"./europe/italy/italy-cities.json": 81296,
	"./europe/london/london-cities.json": 56190,
	"./europe/poland/poland-cities.json": 58098,
	"./europe/portugal/portugal-cities.json": 92962,
	"./europe/prague/prague-cities.json": 71822,
	"./europe/romania/romania-cities.json": 48912,
	"./europe/russia/country-cities.json": 11267,
	"./europe/spain/spain-cities.json": 98808,
	"./middleeast/country/country-cities.json": 60590,
	"./middleeast/egypt/egypt-cities.json": 69950,
	"./middleeast/israel/israel-cities.json": 90272,
	"./middleeast/turkey/turkey-cities.json": 84360,
	"./middleeast/uae/uae-cities.json": 5622,
	"./northamerica/newyork/newyork-cities.json": 73409,
	"./northamerica/sanfrancisco/sanfrancisco-cities.json": 42983,
	"./southamerica/argentina/argentina-cities.json": 35379,
	"./southamerica/brazil/brazil-cities.json": 68793,
	"./southamerica/chile/chile-cities.json": 27359,
	"./southamerica/colombia/colombia-cities.json": 4293,
	"./southamerica/costarica/costarica-cities.json": 67439,
	"./southamerica/country/country-cities.json": 93451,
	"./southamerica/cuba/cuba-cities.json": 27735,
	"./southamerica/ecuador/ecuador-cities.json": 28835,
	"./southamerica/mexico/mexico-cities.json": 19699,
	"./southamerica/peru/peru-cities.json": 65697,
	"./southamerica/puertorico/puertorico-cities.json": 14381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40761;